var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.title)?_c('section',{attrs:{"id":"header-title"}},[_c('div',{staticClass:"container"},[(_vm.title)?_c('h1',[_vm._v("\n            "+_vm._s(_vm.title)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.subTitle)?_c('h2',[_vm._v("\n            "+_vm._s(_vm.subTitle)+"\n        ")]):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }